import { AxiosResponse } from 'axios';
import { getData, postData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

interface GetAccessCodeAllRequest {
  take?: number;
  page?: number;
  strSearch?: string;
  plan?: number;
  duration?: number;
  used?: number;
  inputDuration?: number;
  target?: string;
  filterEmail?: number;
  status?: string;
}

interface GetAccessCodeAllResponse {
  total: number;
  take: number;
  page: number;
  data: any[];
}

interface GenerateOnlyCodePayload {
  subscriptionPlan: number;
  subscriptionDuration: number;
}

interface GenerateMultiCodePayload {
  quantity: number;
  plan?: number;
  duration?: number;
  target?: string;
}

interface DeactivateAccessCodePayload {
  code: string;
  userId: string;
}

export const getAccessCodeRepository = async (
  url: string,
  request: GetAccessCodeAllRequest,
): Promise<GetAccessCodeAllResponse> => {
  const response: AxiosResponse<GetAccessCodeAllResponse> = await getData<
    GetAccessCodeAllRequest,
    GetAccessCodeAllResponse
  >(API_URLS.ACCESS_CODE_LIST, request);
  return response.data;
};

export const generateOnlyCode = (url: string, data: GenerateOnlyCodePayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.ACCESS_CODE_GENERATE, data);
};

export const generateMultiCode = (payload: GenerateMultiCodePayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.ACCESS_CODE_GENERATE_MULTI, payload);
};

export const deactivateAccessCodeRepository = (payload: DeactivateAccessCodePayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.ACCESS_CODE_DEACTIVATE, payload);
};

export const getPurposeRepository = (): Promise<AxiosResponse<any>> => {
  return getData(API_URLS.ACCESS_CODE_PURPOSE);
};
